import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plane, RefreshCw, Save } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";

// Owner: WhatsApp group that receives flight booking requests (platform number must be a member)
export const AlmosaferGroupSetting = () => {
  const [gid, setGid] = useState("");
  const [groups, setGroups] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { api.getAlmosafer().then((d) => setGid(d.group_id || "")).catch(() => {}); }, []);
  const fetchGroups = async () => {
    setBusy("g");
    try { const g = await api.platformWaGroups(); setGroups(g); if (!g.length) toast.info("رقم المنصة ليس عضواً في أي قروب بعد"); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر جلب القروبات"); } finally { setBusy(""); }
  };
  const save = async () => {
    setBusy("s");
    try { await api.setAlmosafer(gid.trim()); toast.success("تم حفظ قروب المسافر"); } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(""); }
  };
  return (
    <div className="space-y-2 rounded-xl border border-sky-200 bg-sky-50/60 p-3" data-testid="almosafer-setting">
      <p className="flex items-center gap-1.5 text-sm font-bold text-sky-800"><Plane className="h-4 w-4" /> قروب «المسافر» لحجوزات الطيران</p>
      <p className="text-xs text-slate-600">أضف رقم واتساب المنصة إلى القروب، ثم اضغط «جلب القروبات» واختره. تصل إليه طلبات الحجز من كل الشركات.</p>
      <div className="flex flex-wrap gap-2">
        <Input dir="ltr" value={gid} onChange={(e) => setGid(e.target.value)} placeholder="1203630xxxxxxxx@g.us" className="h-9 min-w-[220px] flex-1 bg-white" data-testid="almosafer-group-id" />
        <Button size="sm" variant="outline" onClick={fetchGroups} disabled={!!busy} className="h-9 gap-1" data-testid="almosafer-fetch-groups">{busy === "g" ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} جلب القروبات</Button>
        <Button size="sm" onClick={save} disabled={!!busy} className="h-9 gap-1 bg-sky-600 hover:bg-sky-700" data-testid="almosafer-save">{busy === "s" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} حفظ</Button>
      </div>
      {groups?.length > 0 && (
        <div className="flex flex-wrap gap-1.5" data-testid="almosafer-groups">
          {groups.map((g) => <button key={g.id} type="button" onClick={() => setGid(g.id)} className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${gid === g.id ? "border-sky-600 bg-sky-600 text-white" : "border-sky-200 bg-white text-sky-700"}`}>{g.name}</button>)}
        </div>)}
    </div>
  );
};
